import React, {useEffect, useState} from 'react';
import '../styles/ResultDialog.css';

interface ResultDialogProps {
  totalProcessed: number;
  onClose: () => void;
  onDownload: () => void;
}

const ResultDialog: React.FC<ResultDialogProps> = ({ totalProcessed, onClose, onDownload }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  const handleClose = () => {
    setShow(false);
    setTimeout(onClose, 300);
  };

  const handleDownload = () => {
    onDownload();
    handleClose();
  };

  return (
    <div className={`result-dialog-overlay ${show ? 'show' : ''}`} onClick={handleClose}>
      <div className={`result-dialog ${show ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="result-icon">
          <svg className="checkmark" viewBox="0 0 52 52">
            <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>

        <h2 className="result-title">Η Επεξεργασία Ολοκληρώθηκε!</h2>
        <p className="result-message">
          Επεξεργάστηκαν επιτυχώς <strong>{totalProcessed}</strong> όχημα{totalProcessed !== 1 ? 'τα' : ''}
        </p>

        <div className="result-stats">
          <div className="stat-card">
            <div className="stat-icon success">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22 4 12 14.01 9 11.01"/>
              </svg>
            </div>
            <div className="stat-content">
              <div className="stat-value">{totalProcessed}</div>
              <div className="stat-label">Οχήματα Ελέγχθηκαν</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon info">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
                <polyline points="10 9 9 9 8 9"/>
              </svg>
            </div>
            <div className="stat-content">
              <div className="stat-value">Έτοιμα</div>
              <div className="stat-label">Διαθέσιμα Αποτελέσματα</div>
            </div>
          </div>
        </div>

        <div className="result-actions">
          <button className="result-btn primary" onClick={handleDownload}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            Λήψη Αποτελεσμάτων
          </button>
          <button className="result-btn secondary" onClick={handleClose}>
            Προβολή Πίνακα
          </button>
        </div>

        <div className="result-note">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
          <span>Μπορείτε να δείτε τα λεπτομερή αποτελέσματα στον παρακάτω πίνακα ή να κατεβάσετε το αρχείο Excel</span>
        </div>
      </div>
    </div>
  );
};

export default ResultDialog;
